import { getConfig } from './config.js';
import { clearState } from './state.js';
/**
 * Navigate to the configured login path, preserving the current location as
 * a `return_to` query parameter so the auth-service callback can route the
 * user back to the page they were on. Skipped when the user is already on
 * the app root (`/`) — server defaults to that anyway, keeps URLs clean.
 *
 * The auth-service validates `return_to` is an internal path (open-redirect
 * defense lives there, not here).
 */
export function login() {
    const config = getConfig();
    let target = config.loginPath;
    if (typeof window !== 'undefined') {
        const here = window.location.pathname + window.location.search;
        if (here && here !== '/') {
            const sep = target.includes('?') ? '&' : '?';
            target = `${target}${sep}return_to=${encodeURIComponent(here)}`;
        }
    }
    config.redirect(target);
}
/**
 * Clear local state and navigate to the configured logout path. The
 * auth-service handles cookie clearing + IdP token revocation + the final
 * 302 to the IdP's end-session endpoint.
 */
export function logout() {
    clearState();
    const config = getConfig();
    config.redirect(config.logoutPath);
}
//# sourceMappingURL=nav.js.map